export default __webpack_public_path__ + "static/media/mobileTakeAPunt.59a8b6f1.png";